var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/SocialFacebook",
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.304965,2 L4.69503503,2 C3.20673575,2 2.00012231,3.20661344 2.00012231,4.69491271 L2.00012231,19.3048427 C2.00012231,20.7933254 3.20673575,21.9997554 4.69503503,21.9997554 L11.9005293,21.9997554 L11.912944,14.8530934 L10.0560558,14.8530934 C9.81473316,14.8530934 9.61884959,14.6578826 9.61811571,14.4166211 L9.60906458,12.1127416 C9.60808608,11.8702569 9.80470353,11.6729668 10.0471882,11.6729668 L11.9007739,11.6729668 L11.9007739,9.44693928 C11.9007739,6.86382025 13.4784225,5.45722577 15.7827301,5.45722577 L17.6738046,5.45722577 C17.9155554,5.45722577 18.1119282,5.65335396 18.1119282,5.89534937 L18.1119282,7.83779519 C18.1119282,8.0797906 17.9158,8.2759188 17.6740492,8.2759188 L16.5134865,8.27659152 C15.260272,8.27659152 15.0175427,8.87194792 15.0175427,9.74605466 L15.0175427,11.6731503 L17.7712877,11.6731503 C18.0338317,11.6731503 18.2373598,11.9023028 18.2062924,12.1626451 L17.9332296,14.4665246 C17.907177,14.6870541 17.7201611,14.8530934 17.4982249,14.8530934 L15.0300186,14.8530934 L15.0175427,22 L19.304965,22 C20.7932642,22 21.9998777,20.7933254 21.9998777,19.3050261 L21.9998777,4.69491271 C21.9998777,3.20661344 20.7932642,2 19.304965,2",
    id: "Fill-1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/SocialFacebook.a16c44effe7bcf4f0de49b9e1262cf25.svg";
export { ForwardRef as ReactComponent };